import { Button, Layout, Result, Row, Space } from "antd";
import React from "react";
import { useIntl } from "react-intl";
import { env } from "config";

import "./StoreNotAvailable.less";

export function StoreNotAvailable() {
  const intl = useIntl();

  return (
    <Layout className="store-not-available">
      <Row
        justify="center"
        align="middle"
      >
        <Space direction="vertical" align="center">
          <Result
            status="500"
            title={intl.formatMessage({ id: "jmix-store.not-available.title" })}
            subTitle=""
            extra={
              <Button
                type="primary"
                onClick={() => window.location.replace(env.REACT_APP_JMIX_IO)}
              >
                {intl.formatMessage({ id: "jmix-store.not-available.back" })}
              </Button>
            }
          />
        </Space>
      </Row>
    </Layout>
  );
}